/**
 * Shared match card background styling.
 *
 * Layered background using CSS variables emitted from the tenant's matchCard slot:
 * - background-color: var(--match-card-bg-color)  — flat color (or var(--card) fallback)
 * - background-image: var(--match-card-bg-image), var(--match-card-bg)
 *     - first layer: optional URL image (or "none")
 *     - second layer: optional gradient (or "none")
 *
 * Both image vars resolve to "none" when nothing is configured, so the bg-color
 * shows through and the card keeps its default appearance.
 */

/** Inline style to apply the tenant's match card background. */
export const matchCardBackgroundStyle: React.CSSProperties = {
    backgroundColor: "var(--match-card-bg-color)",
    backgroundImage: "var(--match-card-bg-image), var(--match-card-bg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
